import { MuiTheme, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    resetPasswordOuterContainer: {
      height: '819px',
      background: '#D8D8D8',
      color: '#2A2A2A',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      margin: '0px 72px 96px 72px',
      overflow: 'hidden',
      borderRadius: '8px',
      width: 'auto !important',
      [theme.breakpoints.only('md')]: {
        height: '750px !important'
      },
      [theme.breakpoints.down('md')]: {
        height: '100%',
        margin: '0px 0px 40px 0px'
      },
      [theme.breakpoints.only('sm')]: {
        margin: '0px 16px 40px 16px'
      },
      [theme.breakpoints.only('xs')]: {
        margin: '0px 16px 0px 16px'
      }
    },
    resetPasswordImageBlock: {
      width: '50%',
      [theme.breakpoints.up('md')]: {
        flexBasis: '100% !important'
      },
      [theme.breakpoints.between('xs', 'sm')]: {
        width: '100%'
      }
    },
    resetPasswordViewBlock: {
      background: 'white',
      color: '#2A2A2A',
      padding: '96px 72px 96px 40px',
      width: '50%',
      [theme.breakpoints.up('md')]: {
        flexBasis: '100% !important'
      },
      [theme.breakpoints.between('xs', 'sm')]: {
        width: '100%',
        padding: '24px 32px 27px 32px'
      }
    },
    resetPasswordTextBox: {
      flex: 'none',
      background: 'transparent',
      margin: '0px 0px 24px 0px',
      [theme.breakpoints.down('xs')]: {
        margin: '0px 0px 10px 0px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }
    },
    resetPasswordHeader: {
      lineHeight: '1.1',
      fontWeight: 600,
      fontSize: '50px',
      margin: '0px',
      letterSpacing: 'normal',
      [theme.breakpoints.only('sm')]: {
        fontSize: '40px'
      },
      [theme.breakpoints.only('xs')]: {
        fontSize: '23px'
      }
    },
    resetPasswordTextBorder: {
      background: 'transparent',
      margin: '40px 40px 40px 40px',
      [theme.breakpoints.down('sm')]: {
        margin: '12px 40px 0px 40px'
      }
    },
    resetPasswordSubHeader: {
      fontWeight: 500,
      fontSize: '14px',
      margin: '0px',
      letterSpacing: 'normal',
      [theme.breakpoints.only('xs')]: {
        fontSize: '16px'
      }
    },
    resetPasswordInput: {
      flex: 'none',
      background: 'transparent',
      margin: '0px 0px 32px 0px',
      [theme.breakpoints.down('xs')]: {
        margin: '0px 0px 24px 0px'
      },
      // changing the style of textfield
      '& > * > *': {
        [theme.breakpoints.only('xs')]: {
          height: '37px',
          marginBottom: '-10px'
        }
      },
      '& > * > * > input': {
        [theme.breakpoints.only('xs')]: {
          minWidth: '180px'
        }
      }
    },
    resetConfirmPasswordInput: {
      flex: 'none',
      background: 'transparent',
      margin: '0px 0px 24px 0px',
      // changing the style of textfield
      '& > * > *': {
        [theme.breakpoints.only('xs')]: {
          height: '37px',
          marginBottom: '-10px'
        }
      },
      '& > * > * > input': {
        [theme.breakpoints.only('xs')]: {
          minWidth: '180px'
        }
      }
    },
    resetPasswordSaveButton: {
      width: '334px',
      height: '69px',
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        height: '49px',
        fontSize: '18px'
      }
    },
    PasswordResetSuccessBlock: {
      background: 'white',
      color: '#2A2A2A',
      padding: '96px 72px 96px 40px',
      [theme.breakpoints.down('sm')]: {
        padding: '24px 30px 30px 30px'
      }
    },
    resetSuccessMessageBox: {
      background: 'transparent',
      flex: 'none',
      margin: '0px 0px 40px 0px',
      [theme.breakpoints.only('xs')]: {
        margin: '0px 0px 20px 0px'
      }
    },
    resetSuccessHeader: {
      lineHeight: '1.1',
      fontWeight: 600,
      fontSize: '50px',
      margin: '0px',
      letterSpacing: 'normal',
      [theme.breakpoints.only('sm')]: {
        fontSize: '40px'
      },
      [theme.breakpoints.only('xs')]: {
        fontSize: '24px'
      }
    },
    resetSuccessDivider: {
      flex: '1 1 0%',
      background: 'transparent',
      margin: '40px 40px 40px 40px',
      [theme.breakpoints.only('xs')]: {
        margin: '12px 0px 0px 0px'
      }
    },
    resetSuccessSubHeader: {
      fontWeight: 500,
      fontSize: '14px',
      margin: '0px',
      letterSpacing: 'normal',
      [theme.breakpoints.only('xs')]: {
        fontSize: '18px'
      }
    }
  })
);
